export enum CardStatus {
  ACTIVE = 'Active',
  CLOSED = 'Closed',
  BLOCKED = 'Blocked',
  DELINQUENT = 'Delinquent',
  INACTIVE = 'Inactive',
  UNDEFINED = 'Undefined',
  FROZEN = 'Frozen',
}
